import * as React from 'react'

const PrivacyPolicy = () => (
	<div>
		<a
			href="https://www.iubenda.com/privacy-policy/23485076"
			className="hover:underline iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe" title="Privacy Policy"
			target="_blank" rel="noreferrer"
		>
			Privacy Policy
		</a>
		{/* <script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script> */}
	</div>
)

export default PrivacyPolicy
